 document.addEventListener("DOMContentLoaded", function() {
    
    document.querySelectorAll(".variant-selector").forEach(function(select) {
      select.addEventListener("change", function() {
        var selectedOption = this.options[this.selectedIndex];
        var newImage = selectedOption.getAttribute("data-image");
        if (newImage && newImage.trim() !== "") {
          this.closest(".bundle-product").querySelector(".product-image").src = newImage;
        }
      });
    });

    document.querySelector(".add-to-cart").addEventListener("click", function () {
        let quantity = parseInt(document.querySelector(".bndlr-add-to-cart-quantity-input").value);
        let products = document.querySelectorAll(".bundle-product");
        let items = [];
        products.forEach(product => {
            let productId = product.getAttribute("data-product-id");
            let variantSelector = product.querySelector(".variant-selector");
            let variantId = variantSelector ? variantSelector.value : null;

            if (variantId) {
                items.push({
                    id: variantId,
                    quantity: quantity
                });
            }
        });

        if (items.length > 0) {
            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ items: items })
            })
            .then(response => response.json())
            .then(data => {
                console.log("Added to cart", data);
                // window.location.href = "/cart";


           return fetch('/cart.js')
                  .then(response => response.json())
                  .then(cartData => {
                    console.log("Updated Cart:", cartData);
                    if (cartData.item_count === 0) {
                      setTimeout(() => {
                        updateCartDrawer();
                      }, 500); 
                    } else {
                      updateCartDrawer();
                    }
                  });



            })
            .catch(error => console.error("Error adding to cart", error));
        }
    });


function updateCartDrawer() {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
         const updatedDrawerContent = html.querySelector('#Cart-Drawer');
      // if (!document.querySelector("#Cart-Drawer")) {
        let createcartDrawer = document.createElement("cart-drawer");
        // document.body.appendChild(createcartDrawer);
        document.querySelector('#Cart-Drawer').innerHTML = updatedDrawerContent.innerHTML;
      document.querySelectorAll(".cart_img").forEach(img => {
  img.style.display = "none";
});
        let cartDrawer = document.getElementById("Cart-Drawer");
        cartDrawer.setAttribute("open", "true");
      // }
    })
    .catch((e) => {
      console.error("Error updating cart drawer:", e);
    });
}

   
});